import React, { useState} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function FormDialog(props) {
    const {reponse, open, setOpen, onConfirm, title, description } = props;

    //console.log("ReponseForm", reponse);
    let reponseInfos = reponse;

    const [contentValue, setContentValue] = useState(reponseInfos.contenu);
    const [content_enValue, setContent_enValue] = useState(reponseInfos.contenu_en);

    const onContentChange = (e) => setContentValue(e.target.value);
    const onContent_enChange = (e) => setContent_enValue(e.target.value);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
           {description}
          </DialogContentText>
          <TextField
            autoFocus
            id="content"
            label="Reponse en francais"
            fullWidth
            type="name"
            variant="standard"
            onChange={onContentChange}
            value={contentValue}
          />
          <TextField
            id="content_en"
            label="Reponse en anglais"
            type="name"
            fullWidth
            variant="standard"
            onChange={onContent_enChange}
            value={content_enValue}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            reponseInfos.contenu = contentValue;
            reponseInfos.contenu_en = content_enValue;
            onConfirm(reponseInfos);
            setOpen(false);
        }}>Confirm</Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}